<script>
    import LyHeader from '../components/LyHeader.svelte';
    import LyForm from '../forms/LyForm.svelte';
    import LyButtons from '../forms/LyButtons.svelte';
    import LyButton from '../forms/LyButton.svelte';
    import LyFieldset from '../forms/LyFieldset.svelte';
    import LyInputText from '../forms/LyInputText.svelte';
    import LyInputEMail from '../forms/LyInputEMail.svelte';
    import { MessageStore } from '../../stores/MessageStore.svelte.js';
    import { ApiService } from '../../services/ApiService.js';
    import LyInputPassword from '../forms/LyInputPassword.svelte';
    import { onMount } from 'svelte';
    import LyHeadline from '../components/LyHeadline.svelte';

    /**
     * @type {{
     *      email?:string,
     *      openLogin?: () => void
     * }}
     */
    let { email = '', openLogin = () => {} } = $props();

    /** @type {'' | 'code' | 'password'} */
    let resetMode = $state('');
    let disableForm = $state(false);
    let code = $state('');
    let newPassword1 = $state('');
    let newPassword2 = $state('');

    /** @type {HTMLInputElement|null} */
    let passwordInput2 = $state(null);

    const api = new ApiService();

    async function trySendCode() {
        disableForm = true;

        // -
        email = email.trim().toLocaleLowerCase();

        // -
        if (email === '') {
            MessageStore.error('Bitte die E-Mail-Adresse eingeben.');
            disableForm = false;
            return;
        }

        // -
        if (!email.endsWith('@dwc.gmbh')) {
            MessageStore.error('Die E-Mail-Adresse muss mit "@dwc.gmbh" enden.');
            disableForm = false;
            return;
        }

        // -
        const response = await api.callUserResetPasswordCode(email);
        disableForm = false;
        if (response.ok) {
            MessageStore.info('Bitte den E-Mail-Eingang prüfen.');
            resetMode = 'code';
        }
    }

    async function tryValidateCode() {
        disableForm = true;

        // -
        code = code.trim();

        // -
        if (code === '') {
            MessageStore.error('Bitte den Code eingeben.');
            disableForm = false;
            return;
        }

        // -
        if (!/^[a-f0-9]{5}$/i.test(code)) {
            MessageStore.error('Der Code ist nicht gültig.');
            disableForm = false;
            return;
        }

        // -
        const response = await api.callUserValidatePasswordCode(email, code);
        disableForm = false;
        if (response.ok) {
            resetMode = 'password';
        }
    }

    async function trySavePassword() {
        disableForm = true;

        // -
        if (newPassword1.trim() === '') {
            MessageStore.error('Bitte das neue Passwort eingeben.');
            disableForm = false;
            return;
        }

        // -
        if (newPassword1 !== newPassword1.trim()) {
            MessageStore.error('Das Passwort darf keine Leerzeichen enthalten!');
            disableForm = false;
            newPassword1 = '';
            newPassword2 = '';
            return;
        }

        // -
        if (newPassword1 !== newPassword2) {
            MessageStore.error('Die Passwörter stimmen nicht überein!');
            disableForm = false;
            newPassword1 = '';
            newPassword2 = '';
            return;
        }

        // -
        const response = await api.callUserResetPasswordValue(email, code, newPassword1);
        disableForm = false;
        if (response.ok) {
            MessageStore.success('Das Passwort wurde erfolgreich geändert!');
            resetMode = '';
            email = '';
            openLogin();
        } else {
            newPassword1 = '';
            newPassword2 = '';
        }
    }

    onMount(() => {
        if (email !== '') {
            trySendCode();
        }
    });
</script>

<LyHeader>
    <LyHeadline>
        {#if resetMode === 'password'}
            Passwort vergeben&hellip;
        {:else if resetMode === 'code'}
            Passwort ändern&hellip;
        {:else}
            Passwort vergessen?
        {/if}
    </LyHeadline>
</LyHeader>
<LyForm mt="4" tag="div">
    {#if resetMode === 'password'}
        <LyFieldset border={false}>
            <LyInputText label="E-Mail-Adresse" bind:value={email} disabled={true} />
            <LyInputPassword
                name="newPassword1"
                required={true}
                label="Neues Passwort"
                placeholder=""
                autofocus={true}
                bind:value={newPassword1}
                onkeydown={(e) => e.key === 'Enter' && passwordInput2?.focus()} />
            <LyInputPassword
                name="newPassword2"
                required={true}
                label="Passwort wiederholen"
                placeholder=""
                bind:thisRef={passwordInput2}
                bind:value={newPassword2}
                onkeydown={(e) => e.key === 'Enter' && trySavePassword()} />
        </LyFieldset>
        <LyButtons>
            <LyButton label="Speichern" disabled={disableForm} onclick={trySavePassword} />
        </LyButtons>
    {:else if resetMode === 'code'}
        <LyFieldset border={false}>
            <LyInputText label="E-Mail-Adresse" bind:value={email} disabled={true} />
            <LyInputText
                name="code"
                required={true}
                label="Code"
                placeholder=""
                autofocus={true}
                bind:value={code}
                onkeydown={(e) => e.key === 'Enter' && tryValidateCode()} />
        </LyFieldset>
        <LyButtons>
            <LyButton label="Code prüfen" disabled={disableForm} onclick={tryValidateCode} />
        </LyButtons>
    {:else}
        <LyFieldset border={false}>
            <LyInputEMail
                name="email"
                required={true}
                autofocus={true}
                label="E-Mail-Adresse"
                placeholder="x.y@dwc.gmbh"
                autocomplete="email"
                bind:value={email}
                onkeydown={(e) => e.key === 'Enter' && trySendCode()} />
        </LyFieldset>
        <LyButtons>
            <LyButton label="Code anfordern" disabled={disableForm} onclick={trySendCode} />
        </LyButtons>
    {/if}
    <LyButtons mt={true}>
        <LyButton label="Zurück" color={true} onclick={openLogin} />
    </LyButtons>
</LyForm>
